import { DocumentationSyncPanel } from "~/features/console/DocumentationSyncPanel";

/** Registry wrapper — the surface itself lives with the rest of the IDE feature. */
export function DocumentationSync() {
  return <DocumentationSyncPanel />;
}
